export type CartTimerStatus = "default" | "warning" | "error";

export type CartTimerResult = {
    display: string;
    status: CartTimerStatus;
    remainingMs: number;
};

const WARNING_THRESHOLD_MS = 10 * 60 * 1000;
const ERROR_THRESHOLD_MS = 5 * 60 * 1000;

export const getRemainingMs = (expiresAt: string | undefined): number => {
    if (!expiresAt) {
        return 0;
    }

    return Math.max(0, new Date(expiresAt).getTime() - Date.now());
};

export const formatRemainingTime = (remainingMs: number): string => {
    const totalSeconds = Math.floor(remainingMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

export const getTimerStatus = (remainingMs: number): CartTimerStatus => {
    if (remainingMs <= ERROR_THRESHOLD_MS) {
        return "error";
    }

    if (remainingMs <= WARNING_THRESHOLD_MS) {
        return "warning";
    }

    return "default";
};

export const getReservationTimer = (
    expiresAt: string | undefined,
): CartTimerResult => {
    const remainingMs = getRemainingMs(expiresAt);

    return {
        display: formatRemainingTime(remainingMs),
        status: getTimerStatus(remainingMs),
        remainingMs,
    };
};
